var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChipGeneric',{key:'item_'+_vm.item.value,attrs:{"item":_vm.computed_item},on:{"update":_vm.chip_clicked}})
}
var staticRenderFns = []

export { render, staticRenderFns }